import type { HistoryDir, SugarObject, SugarStateSlice } from "./SugarObject";

export type { HistoryDir };

export function cloneStateValue<T>(value: T): T {
  if (value === undefined || value === null) return value;
  if (typeof structuredClone === "function") {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value)) as T;
}

export function restoreStateSlice(
  target: SugarObject,
  slice: SugarStateSlice,
  dir: HistoryDir,
): void {
  target.applyState?.(slice, dir);
}

export function stateSlicesEqual(
  a: SugarStateSlice,
  b: SugarStateSlice,
): boolean {
  if (a.kind !== b.kind) return false;
  return JSON.stringify(a.value) === JSON.stringify(b.value);
}

export function documentsEqual(
  a: Record<string, SugarStateSlice>,
  b: Record<string, SugarStateSlice>,
): boolean {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  for (const key of keysA) {
    const sa = a[key];
    const sb = b[key];
    if (!sb || !stateSlicesEqual(sa, sb)) return false;
  }
  return true;
}
